// Init
function init() {
    animCursorPos();
    animSearchForm();
    // animDetails();
}
if (document.readyState === 'interactive' || document.readyState === 'complete' && (name === 'DOMContentLoaded' || name === 'load')) {
    setTimeout(init);  // Using setTimeout doesn't block main thread and tells browser to run it when it can
} else {
    document.addEventListener('DOMContentLoaded', init);
}

// Set a <span> on specific buttons for hover anim
const animCursorPos = () => {
    const buttons = document.querySelectorAll(".btn-navigation")
    buttons.forEach((button) => {
        const span = document.createElement("span")
        button.appendChild(span);

        [ "mouseenter", "mouseout" ].forEach(evt => {
            button.addEventListener((evt), (e) => {
                const parentOffset = button.getBoundingClientRect();
                let relX = e.pageX - (window.scrollX + parentOffset.left);
                let relY = e.pageY - (window.scrollY + parentOffset.top);
                span.style.top = relY + "px";
                span.style.left = relX + "px"
            })
        })
    })
}

// Move search cursor and reveal input
const animSearchForm = () => {
    const searchBtn = document.querySelector('.search-btn');
    if (!searchBtn) return;

    const formEl = searchBtn.parentElement;

    // Disable autocomplete because it hides search button
    formEl.setAttribute('autocomplete', 'off');
    formEl.querySelectorAll('input').forEach(el => el.setAttribute('autocomplete', 'off'));

    let translateClass
    searchBtn.addEventListener('click', ev => {
        if (formEl.className.includes('translate-x')) {
            [ ...formEl.classList ].map(className => {
                if (className?.includes('translate-x')) {

                    translateClass = className;
                    formEl.classList.remove(className)

                    // Wait for transition to end
                    formEl.addEventListener('transitionend', () => {
                        // Set focus on search
                        searchBtn.nextElementSibling.focus()
                        searchBtn.nextElementSibling.select()
                    })

                }
            })
        } else {
            // Turn button into submit
            searchBtn.nextElementSibling?.value ?
                searchBtn.setAttribute('type', 'submit') :
                searchBtn.nextElementSibling.focus();
        }
    });
}

const animDetails = () => {

    const setHeight = (detail, open = false) => {
        detail.open = open;
        const rect = detail.getBoundingClientRect();
        detail.dataset.width = rect.width;
        detail.style.setProperty(open ? `--expanded` : `--collapsed`,`${rect.height}px`);
    }
    const details = document.querySelectorAll('details');
    const RO = new ResizeObserver(entries => {
        return entries.forEach(entry => {
            const detail = entry.target;
            const initialDetailState = detail?.open;
            const width = parseInt(detail.dataset.width, 10);
            if (width !== entry.contentRect.width) {
                detail.removeAttribute('style');
                setHeight(detail);
                setHeight(detail, true);
                detail.open = initialDetailState;
            }
        })
    });
    details.forEach(detail => {
        RO.observe(detail);
    });
    
}
